import React, { useCallback, useState, useEffect, useRef } from "react";
import {
  DropZone,
  Stack,
  FormLayout,
  TextField,
  Thumbnail,
  Checkbox,
  Toast,
  Icon,
  Popover,
  ActionList,
  Button,
  Text,
  Loading,
  ChoiceList,
  Select,
  InlineError,
  Modal,
  TextContainer,
  ButtonGroup,
  Tooltip,
} from "@shopify/polaris";
import { useParams } from "react-router-dom";
import axios from "../Assets/Lib/axios";
import {
  NoteMinor,
  LanguageMinor,
  MobileVerticalDotsMajor,
  ColorsMajor,
} from "@shopify/polaris-icons";
import { Editor } from "@tinymce/tinymce-react";
import EditorTiny from "./EditorTiny";
import showTools from "../Assets/Images/show-tools.svg";
import hideTools from "../Assets/Images/hide-tools.svg";
import Instruction from "./Instruction";
import { accessEditSections } from "../Helpers";
import axiosDefault from "axios";
import LoadingScreen from "../Components/LoadingScreen";
import AsyncSelect from "react-select/async";
import instructionImg from "../Assets/Images/instruction-help.svg";
import JoditEditor from "jodit-react";
import JoditEditorComponent from "./JoditEditor";

const ImageWithTextSection = (props) => {
  const [isSaving, setIsSaving] = useState(false);
  const refId = useRef(null);
  const [boolRichTextTools, setBoolRichTextTools] = useState(false);
  let object = JSON.parse(props.object);
  const [data, setData] = useState([]);
  const { id } = useParams();
  const [selectedLanguage, setSelectedLanguage] = useState("");
  const handleSelectChangeLanguage = (value) => {
    setSelectedLanguage(value);
  };
  const [translatedButtonClicked, setTranslatedButtonClicked] = useState(false);
  const handleTranslate = () => {
    setTranslatedButtonClicked(!translatedButtonClicked);
  };
  const handleChangeTitle = (value) => {
    const newState = data.map((obj) => {
      if (obj.language === "en") {
        return { ...obj, title: value };
      }
      return obj;
    });
    setData(newState);
  };
  const handleChangeSubtitle = (value) => {
    const newState = data.map((obj) => {
      if (obj.language === "en") {
        return { ...obj, subtitle: value };
      }
      return obj;
    });
    setData(newState);
  };
  const handleChangeCtaText = (value) => {
    const newState = data.map((obj) => {
      if (obj.language === "en") {
        return { ...obj, ctaText: value };
      }
      return obj;
    });
    setData(newState);
  };
  const handleChangeCtaLink = (value) => {
    const newState = data.map((obj) => {
      if (obj.language === "en") {
        return { ...obj, ctaLink: value };
      }
      return obj;
    });
    setData(newState);
  };
  const handleChangeText = (value) => {
    const newState = data.map((obj) => {
      if (obj.language === "en") {
        return { ...obj, text: value };
      }
      return obj;
    });
    setData(newState);
  };
  const handleChangeTitleTranslated = (value) => {
    const newState = data.map((obj) => {
      if (obj.language === selectedLanguage) {
        return { ...obj, title: value };
      }
      return obj;
    });
    setData(newState);
  };
  const handleChangeSubtitleTranslated = (value) => {
    const newState = data.map((obj) => {
      if (obj.language === selectedLanguage) {
        return { ...obj, subtitle: value };
      }
      return obj;
    });
    setData(newState);
  };

  const handleChangeCtaTextTranslated = (value) => {
    const newState = data.map((obj) => {
      if (obj.language === selectedLanguage) {
        return { ...obj, ctaText: value };
      }
      return obj;
    });
    setData(newState);
  };
  const handleChangeCtaLinkTranslated = (value) => {
    const newState = data.map((obj) => {
      if (obj.language === selectedLanguage) {
        return { ...obj, ctaLink: value };
      }
      return obj;
    });
    setData(newState);
  };
  const handleChangeTextTranslated = (value) => {
    const newState = data.map((obj) => {
      if (obj.language === selectedLanguage) {
        return { ...obj, text: value };
      }
      return obj;
    });
    setData(newState);
  };
  const [checked, setChecked] = useState(false);
  const handleChange = (newChecked) => {
    const newState = data.map((obj) => {
      if (obj.language === "en") {
        return { ...obj, active: newChecked };
      }
      return obj;
    });
    setData(newState);
  };
  const [file, setFile] = useState();
  const handleDropZoneDrop = useCallback(
    (_dropFiles, acceptedFiles, _rejectedFiles) =>
      setFile((file) => acceptedFiles[0]),
    []
  );

  const validImageTypes = [
    "image/gif",
    "image/jpeg",
    "image/png",
    "image/json",
  ];
  const fileUpload = !file && (
    <DropZone.FileUpload
      actionHint={"Accepts pngs, jpegs, svgs, jsons, gifs and webp"}
    />
  );
  const uploadedFile = file && (
    <Stack>
      {/* <Thumbnail
        size="small"
        alt={file.name}
        source={
          validImageTypes.includes(file.type)
            ? window.URL.createObjectURL(file)
            : NoteMinor
        }
      /> */}
      <div className="maxtextwidth">
        {file.name}{" "}
        <Text variant="bodySm" as="p">
          {file.size} bytes
        </Text>
      </div>
    </Stack>
  );
  const [imageError, setImageError] = useState("");

  const imageKey = useRef("");
  const [isImageUploading, setIsImageUploading] = useState(false);
  const sendImage = (file) => {
    setIsImageUploading(true);
    const form_data = new FormData();
    form_data.append("entity_type", "section");
    form_data.append("section_type", "image");
    form_data.append("image[en]", file[file.length - 1]);
    axios
      .post(`/s3/save-file`, form_data)
      .then((result) => {
        imageKey.current = result.data.data.file_key;
        setIsImageUploading(false);
        const newState = data.map((obj) => {
          if (obj.language === "en") {
            return {
              ...obj,
              fileImage: imageKey.current,
              image:
                validImageTypes.indexOf(file[file.length - 1].type) > 0
                  ? window.URL.createObjectURL(file[file.length - 1])
                  : "https://cdn.shopify.com/s/files/1/0757/9955/files/New_Post.png?12678548500147524304",
            };
          }
          return obj;
        });
        setData(newState);
        setImageError("");
      })
      .catch(function (error) {});
  };

  const [fileTranslated, setFileTranslated] = useState();
  const handleDropZoneDropTranslated = useCallback(
    (_dropFiles, acceptedFiles, _rejectedFiles) =>
      setFileTranslated((fileTranslated) => acceptedFiles[0]),
    []
  );
  const fileUploadTranslated = !fileTranslated && (
    <DropZone.FileUpload
      actionHint={"Accepts pngs, jpegs, svgs, jsons, gifs and webp"}
    />
  );
  const uploadedFileTranslated = fileTranslated && (
    <Stack>
      {/* <Thumbnail
        size="small"
        alt={file.name}
        source={
          validImageTypes.includes(file.type)
            ? window.URL.createObjectURL(file)
            : NoteMinor
        }
      /> */}
      <div className="maxtextwidth">
        {fileTranslated.name}{" "}
        <Text variant="bodySm" as="p">
          {fileTranslated.size} bytes
        </Text>
      </div>
    </Stack>
  );
  const sendImageTranslated = (fileTranslated) => {
    setIsImageUploading(true);
    const form_data = new FormData();
    form_data.append("entity_type", "section");
    form_data.append("section_type", "image");
    form_data.append(
      `image[${selectedLanguage}]`,
      fileTranslated[fileTranslated.length - 1]
    );
    axios
      .post(`/s3/save-file`, form_data)
      .then((result) => {
        imageKey.current = result.data.data.file_key;
        setIsImageUploading(false);
        const newState = data.map((obj) => {
          if (obj.language === selectedLanguage) {
            return {
              ...obj,
              fileImage: imageKey.current,
              image:
                validImageTypes.indexOf(
                  fileTranslated[fileTranslated.length - 1].type
                ) > 0
                  ? window.URL.createObjectURL(
                      fileTranslated[fileTranslated.length - 1]
                    )
                  : "https://cdn.shopify.com/s/files/1/0757/9955/files/New_Post.png?12678548500147524304",
            };
          }
          return obj;
        });
        setData(newState);
      })
      .catch(function (error) {});
  };
  const optionsPosition = [
    { label: "Left", value: "left" },
    { label: "Right", value: "right" },
  ];
  const [positionError, setPositionError] = useState("");
  const handleSelectChangePosition = (value) => {
    const newState = data.map((obj) => {
      if (obj.language === "en") {
        return {
          ...obj,
          position: value,
        };
      }
      return obj;
    });
    setData(newState);
    setPositionError("");
  };
  const handleChangeTemplate = (newValue) => {
    const newState = data.map((obj) => {
      if (obj.language === "en") {
        return { ...obj, template: newValue };
      }
      return obj;
    });
    setData(newState);
  };
  useEffect(() => {
    !props.shopifyDomainFound &&
      setOptionsCtaLinkType(
        optionsCtaLinkType.filter(
          (item) =>
            item.label !== "Shopify Product" &&
            item.label !== "Shopify Collection"
        )
      );
    object = JSON.parse(props.object);
    setData(
      props.languagesArray
        .concat([{ label: "English", value: "en" }])
        .map((element, index) => {
          return {
            language: element.value,
            instruction: object?.instructions ? object?.instructions : "",
            title:
              object?.title && object?.title[element.value]
                ? object?.title[element.value]
                : "",
            subtitle:
              object?.subtitle && object?.subtitle[element.value]
                ? object?.subtitle[element.value]
                : "",
            ctaLinkType:
              object?.details?.cta_link_type !== null
                ? String(object?.details?.cta_link_type)
                : "",
            ctaText:
              object?.details?.cta_text &&
              object?.details?.cta_text[element.value]
                ? object?.details?.cta_text[element.value]
                : "",
            ctaLink:
              object?.details?.cta_link &&
              object?.details?.cta_link[element.value]
                ? object?.details?.cta_link[element.value]
                : "",
            ctaLinkPage: object?.details?.cta_page_alias
              ? object?.details?.cta_page_alias
              : "",
            ctaLinkBlog: object?.details?.cta_blog_alias
              ? object?.details?.cta_blog_alias
              : "",
            ctaLinkCollection: {
              label:
                object?.details && object?.details?.cta_shopify_collection_title
                  ? object?.details?.cta_shopify_collection_title
                  : "",
              value:
                object?.details && object?.details?.cta_shopify_collection_id
                  ? object?.details?.cta_shopify_collection_id
                  : "",
              handle:
                object?.details &&
                object?.details?.cta_shopify_collection_handle
                  ? object?.details?.cta_shopify_collection_handle
                  : "",
            },

            ctaLinkProduct: {
              label:
                object?.details && object?.details?.cta_shopify_product_title
                  ? object?.details?.cta_shopify_product_title
                  : "",
              value:
                object?.details && object?.details?.cta_shopify_product_id
                  ? object?.details?.cta_shopify_product_id
                  : "",
              handle:
                object?.details && object?.details?.cta_shopify_product_id
                  ? object?.details?.cta_shopify_product_id
                  : "",
            },
            text:
              object?.details?.text && object?.details?.text[element.value]
                ? object?.details?.text[element.value]
                : "",
            position: object?.details?.image_position
              ? object?.details?.image_position
              : "",
            fileImage: "",
            image:
              object?.details?.image && object?.details?.image[element.value]
                ? object?.details?.image[element.value]
                : "",
            active: object?.details?.is_active ? true : false,
            template:
              object?.template_id !== null
                ? String(object?.template_id)
                : props.templates[0]?.id
                ? props.templates[0]?.id
                : "",
            file_pdf: object?.details?.document_url
              ? "https://cdn.shopify.com/s/files/1/0757/9955/files/New_Post.png?12678548500147524304"
              : "",
          };
        })
    );
  }, [props.object]);
  const [popoverActive, setPopoverActive] = useState(false);
  const togglePopoverActive = useCallback(
    () => setPopoverActive((popoverActive) => !popoverActive),
    []
  );
  const activator = (
    <Button onClick={togglePopoverActive} plain>
      <Icon source={MobileVerticalDotsMajor} />
    </Button>
  );

  const [active, setActive] = useState(false);
  const toggleActive = useCallback(() => setActive((active) => !active), []);
  const [toastContent, setToastContent] = useState(
    "This image have been successfully deleted"
  );
  const toastMarkup = active ? (
    <Toast content={toastContent} onDismiss={toggleActive} />
  ) : null;
  const [activeDelete, setActiveDelete] = useState(false);
  const handleChangeModalDelete = useCallback((activeDelete) => {
    setActiveDelete(!activeDelete);
    setIsSaving(false);
  }, []);
  const handleDeleteImage = (field, language) => {
    refId.current = field + ";" + language;
    console.log(field + ";" + language);
    setActiveDelete(true);
  };

  const handleYesDelete = () => {
    setIsSaving(true);
    const form_data = new FormData();
    form_data.append("_method", "PATCH");
    form_data.append("entity_type", "section");
    form_data.append("entity_id", props.sectionId);
    form_data.append("field", refId.current.split(";")[0]);
    form_data.append("language_code", refId.current.split(";")[1]);
    axios
      .post(`/remove/image`, form_data)
      .then((result) => {
        toggleActive();
        setIsSaving(false);
        setActiveDelete(!activeDelete);
        const newState = data.map((obj) => {
          if (obj.language === refId.current.split(";")[1]) {
            if (refId.current.split(";")[0] === "image")
              return {
                ...obj,
                image: "",
              };
            else
              return {
                ...obj,
                mobileImage: "",
              };
          }
          return obj;
        });
        setData(newState);
      })
      .catch((err) => console.log(err));
  };
  const handleSelectChangeCtaLinkType = (value) => {
    const newState = data.map((obj) => {
      if (obj.language === "en") {
        return { ...obj, ctaLinkType: value };
      }
      return obj;
    });
    setData(newState);
    //setInputValueCollection("");
  };

  const [optionsCtaLinkType, setOptionsCtaLinkType] = useState([
    { label: "External Link", value: "1" },
    { label: "Page", value: "2" },
    { label: "Blog", value: "3" },
    { label: "Shopify Product", value: "4" },
    { label: "Shopify Collection", value: "5" },
  ]);
  const [selectedPage, setSelectedPage] = useState("");
  const handleSelectChangePage = (value) => {
    const newState = data.map((obj) => {
      if (obj.language === "en") {
        return { ...obj, ctaLinkPage: value };
      }
      return obj;
    });
    setData(newState);
    //setInputValueCollection("");
  };
  const handleSelectChangeBlog = (value) => {
    const newState = data.map((obj) => {
      if (obj.language === "en") {
        return { ...obj, ctaLinkBlog: value };
      }
      return obj;
    });
    setData(newState);
    //setInputValueCollection("");
  };
  const [selectedShopifyCollection, setSelectedShopifyCollection] =
    useState("");
  const handleSelectChangeShopifyCollection = (value) => {
    const newState = data.map((obj) => {
      if (obj.language === "en") {
        return { ...obj, ctaLinkCollection: value };
      }
      return obj;
    });
    setData(newState);
    //setInputValueCollection("");
  };
  const [selectedShopifyProduct, setSelectedShopifyProduct] = useState("");
  const handleSelectChangeShopifyProduct = (value) => {
    const newState = data.map((obj) => {
      if (obj.language === "en") {
        return { ...obj, ctaLinkProduct: value };
      }
      return obj;
    });
    setData(newState);
    //setInputValueCollection("");
  };

  const [
    firstTimeLoadedCollectionsOptions,
    setFirstTimeLoadedCollectionsOptions,
  ] = useState([]);

  const loadOptionsCollections = (inputValue, callback) => {
    axios
      .get(`/shopify-collections?search=${inputValue}`)
      .then((result) => {
        setTimeout(() => {
          callback(
            result.data.data.map((item, index) => {
              return {
                label: item.title,
                value: String(item.id),
                handle: item.handle,
              };
            })
          );
        }, 0);
        setFirstTimeLoadedCollectionsOptions(
          result.data.data.map((item, index) => {
            return {
              label: item.title,
              value: String(item.id),
              handle: item.handle,
            };
          })
        );
      })
      .catch((err) => console.log(err));
  };

  const [firstTimeLoadedProductsOptions, setFirstTimeLoadedProductsOptions] =
    useState([]);
  const loadOptionsProducts = (inputValue, callback) => {
    axios
      .get(`/shopify-products?search=${inputValue}`)
      .then((result) => {
        setTimeout(() => {
          callback(
            result.data.data.map((item, index) => {
              return {
                label: item.title,
                value: String(item.id),
                handle: item.handle,
              };
            })
          );
        }, 0);
        setFirstTimeLoadedProductsOptions(
          result.data.data.map((item, index) => {
            return {
              label: item.title,
              value: String(item.id),
              handle: item.handle,
            };
          })
        );
      })
      .catch((err) => console.log(err));
  };

  // ----------------------------
  // PDF / DOC Upload (Not Translated)
  // ----------------------------
  const [pdfFile, setPdfFile] = useState(null);
  const [pdfFileKey, setPdfFileKey] = useState("");

  const handleDropZoneDropPdf = useCallback(
    (_dropFiles, acceptedFiles, _rejectedFiles) => setPdfFile(acceptedFiles[0]),
    []
  );

  const sendPdfFile = (file) => {
    const form_data = new FormData();
    setIsImageUploading(true);
    form_data.append("entity_type", "section");
    form_data.append("section_type", "image");
    form_data.append("document", file[file.length - 1]); // only one file

    axios
      .post(`/s3/save-file`, form_data)
      .then((res) => {
        setPdfFileKey(res.data.data.file_key);
        setIsImageUploading(false);
      })
      .catch(() => {
        setIsImageUploading(false);
      });
  };

  return (
    <FormLayout>
      {/* <Instruction
        text={
          findArrayElementByLanguage(data, "en") &&
          findArrayElementByLanguage(data, "en").instruction
        }
        pageId={id}
        sectionId={props.sectionId}
        handleRefreshSections={props.handleRefreshSections}
      /> */}
      <div style={{ float: "right" }}>
        <ButtonGroup>
          <Button
            onClick={() => {
              setBoolRichTextTools(!boolRichTextTools);
            }}
            plain
          >
            <img src={boolRichTextTools ? showTools : hideTools} width={22} />
          </Button>
          <Button
            plain
            onClick={handleTranslate}
            icon={!translatedButtonClicked ? LanguageMinor : ""}
          >
            {translatedButtonClicked ? "Edit English" : "Translate"}
          </Button>
          {/* <Button
            plain
            onClick={() => props.handleCustomizeStyles()}
            icon={ColorsMajor}
          >
            Customize Styles
          </Button> */}
        </ButtonGroup>
      </div>

      <table>
        <tbody>
          <tr>
            <th>
              <Text variant="bodyMd" as="p" fontWeight="medium"></Text>
            </th>
            <th>
              <Text variant="bodyMd" as="p" fontWeight="medium"></Text>
            </th>
            {translatedButtonClicked && (
              <th>
                <Select
                  options={props.languagesArray}
                  onChange={handleSelectChangeLanguage}
                  value={selectedLanguage}
                  placeholder="Please select a language"
                />
              </th>
            )}
          </tr>
          <tr>
            <td>
              <Text variant="bodyMd" as="p" color="subdued">
                Title
              </Text>
            </td>
            <td>
              <TextField
                value={
                  findArrayElementByLanguage(data, "en") &&
                  findArrayElementByLanguage(data, "en").title
                }
                onChange={handleChangeTitle}
                disabled={translatedButtonClicked}
              />
              {/* <EditorTiny
                boolRichTextTools={boolRichTextTools}
                value={
                  findArrayElementByLanguage(data, "en") &&
                  findArrayElementByLanguage(data, "en").title
                }
                handleChangeValue={handleChangeTitle}
                disabled={translatedButtonClicked}
                height={100}
              /> */}
            </td>
            {translatedButtonClicked && (
              <td>
                <TextField
                  value={
                    findArrayElementByLanguage(data, selectedLanguage) &&
                    findArrayElementByLanguage(data, selectedLanguage).title
                  }
                  onChange={handleChangeTitleTranslated}
                />
                {/* <EditorTiny
                  boolRichTextTools={boolRichTextTools}
                  value={
                    findArrayElementByLanguage(data, selectedLanguage) &&
                    findArrayElementByLanguage(data, selectedLanguage).title
                  }
                  handleChangeValue={handleChangeTitleTranslated}
                  height={100}
                /> */}
              </td>
            )}
          </tr>

          <tr>
            <td>
              <Text variant="bodyMd" as="p" color="subdued">
                Subtitle
              </Text>
            </td>
            <td>
              <TextField
                value={
                  findArrayElementByLanguage(data, "en") &&
                  findArrayElementByLanguage(data, "en").subtitle
                }
                onChange={handleChangeSubtitle}
                disabled={translatedButtonClicked}
              />
            </td>
            {translatedButtonClicked && (
              <td>
                <TextField
                  value={
                    findArrayElementByLanguage(data, selectedLanguage) &&
                    findArrayElementByLanguage(data, selectedLanguage).subtitle
                  }
                  onChange={handleChangeSubtitleTranslated}
                />
              </td>
            )}
          </tr>

          <tr>
            <td>
              <Text variant="bodyMd" as="p" color="subdued">
                CTA Text
              </Text>
            </td>
            <td>
              <TextField
                value={
                  findArrayElementByLanguage(data, "en") &&
                  findArrayElementByLanguage(data, "en").ctaText
                }
                onChange={handleChangeCtaText}
                disabled={translatedButtonClicked}
              />
            </td>
            {translatedButtonClicked && (
              <td>
                <TextField
                  value={
                    findArrayElementByLanguage(data, selectedLanguage) &&
                    findArrayElementByLanguage(data, selectedLanguage).ctaText
                  }
                  onChange={handleChangeCtaTextTranslated}
                />
              </td>
            )}
          </tr>
          <tr>
            <td>
              <Text variant="bodyMd" as="p" color="subdued">
                CTA Link
              </Text>
            </td>

            <td className="rowDiv">
              <div style={{ width: "50%" }}>
                <Select
                  options={optionsCtaLinkType}
                  onChange={handleSelectChangeCtaLinkType}
                  value={
                    findArrayElementByLanguage(data, "en") &&
                    findArrayElementByLanguage(data, "en").ctaLinkType
                  }
                  // value={selectedCtaLinkType}
                  placeholder="Please select"
                />
              </div>
              <div style={{ width: "50%" }} className="ms-2">
                {findArrayElementByLanguage(data, "en") &&
                  findArrayElementByLanguage(data, "en").ctaLinkType ===
                    "1" && (
                    <TextField
                      value={
                        findArrayElementByLanguage(data, "en") &&
                        findArrayElementByLanguage(data, "en").ctaLink
                      }
                      onChange={handleChangeCtaLink}
                      disabled={translatedButtonClicked}
                    />
                  )}
                {findArrayElementByLanguage(data, "en") &&
                  findArrayElementByLanguage(data, "en").ctaLinkType ===
                    "4" && (
                    <AsyncSelect
                      cacheOptions
                      defaultOptions={firstTimeLoadedProductsOptions}
                      loadOptions={loadOptionsProducts}
                      onChange={handleSelectChangeShopifyProduct}
                      menuPortalTarget={document.body}
                      styles={{
                        menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                      }}
                      value={
                        findArrayElementByLanguage(data, "en") &&
                        findArrayElementByLanguage(data, "en").ctaLinkProduct
                      }
                    />
                    // <Autocomplete
                    //   options={optionsCollections}
                    //   selected={selectedOptions}
                    //   onSelect={updateSelection}
                    //   textField={textField}
                    // />
                  )}
                {findArrayElementByLanguage(data, "en") &&
                  findArrayElementByLanguage(data, "en").ctaLinkType ===
                    "5" && (
                    <AsyncSelect
                      cacheOptions
                      defaultOptions={firstTimeLoadedCollectionsOptions}
                      loadOptions={loadOptionsCollections}
                      onChange={handleSelectChangeShopifyCollection}
                      menuPortalTarget={document.body}
                      styles={{
                        menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                      }}
                      value={
                        findArrayElementByLanguage(data, "en") &&
                        findArrayElementByLanguage(data, "en").ctaLinkCollection
                      }
                    />

                    // <Autocomplete
                    //   options={optionsCollections}
                    //   selected={selectedOptions}
                    //   onSelect={updateSelection}
                    //   textField={textField}
                    // />
                  )}

                {findArrayElementByLanguage(data, "en") &&
                  findArrayElementByLanguage(data, "en").ctaLinkType ===
                    "2" && (
                    <Select
                      options={props.pagesArray}
                      onChange={handleSelectChangePage}
                      value={
                        findArrayElementByLanguage(data, "en") &&
                        findArrayElementByLanguage(data, "en").ctaLinkPage
                      }
                      placeholder="Please select"
                    />
                  )}
                {findArrayElementByLanguage(data, "en") &&
                  findArrayElementByLanguage(data, "en").ctaLinkType ===
                    "3" && (
                    <Select
                      options={props.blogsArray}
                      onChange={handleSelectChangeBlog}
                      value={
                        findArrayElementByLanguage(data, "en") &&
                        findArrayElementByLanguage(data, "en").ctaLinkBlog
                      }
                      placeholder="Please select"
                    />
                  )}
              </div>
            </td>
            {translatedButtonClicked &&
              findArrayElementByLanguage(data, "en") &&
              findArrayElementByLanguage(data, "en").ctaLinkType === "1" && (
                <td>
                  <TextField
                    value={
                      findArrayElementByLanguage(data, selectedLanguage) &&
                      findArrayElementByLanguage(data, selectedLanguage).ctaLink
                    }
                    onChange={handleChangeCtaLinkTranslated}
                  />
                </td>
              )}
          </tr>
          {/* <tr>
            <td>
              <Text variant="bodyMd" as="p" color="subdued">
                CTA Link
              </Text>
            </td>
            <td>
              <TextField
                value={
                  findArrayElementByLanguage(data, "en") &&
                  findArrayElementByLanguage(data, "en").ctaLink
                }
                onChange={handleChangeCtaLink}
                disabled={translatedButtonClicked}
              />
            </td>
            {translatedButtonClicked && (
              <td>
                <TextField
                  value={
                    findArrayElementByLanguage(data, selectedLanguage) &&
                    findArrayElementByLanguage(data, selectedLanguage).ctaLink
                  }
                  onChange={handleChangeCtaLinkTranslated}
                />
              </td>
            )}
          </tr> */}
          <tr>
            <td>
              <Text variant="bodyMd" as="p" color="subdued">
                Text
              </Text>
            </td>
            <td>
              <JoditEditorComponent
                boolRichTextTools={boolRichTextTools}
                value={
                  findArrayElementByLanguage(data, "en") &&
                  findArrayElementByLanguage(data, "en").text
                }
                handleChangeValue={handleChangeText}
                disabled={translatedButtonClicked}
                height={200}
              />

              {/* <Editor
                disabled={translatedButtonClicked}
                apiKey="7e5qugyswmfji644700m0pos9pozwpesrtdbyflsqx2s0zsf"
                value={
                  findArrayElementByLanguage(data, "en") &&
                  findArrayElementByLanguage(data, "en").text
                }
                init={{
                  readonly: 1,
                  branding: false,
                  height: 200,
                  menubar: false,
                  plugins: [
                    "advlist autolink lists link image charmap print preview anchor",
                    "searchreplace visualblocks code fullscreen",
                    "insertdatetime media table paste code help wordcount",
                  ],
                  toolbar:
                    "undo redo | formatselect | bold italic backcolor | \
alignleft aligncenter alignright alignjustify | \
bullist numlist outdent indent | removeformat | help|code",
                }}
                onEditorChange={handleChangeText}
              /> */}
            </td>
            {translatedButtonClicked && (
              <td>
                <JoditEditorComponent
                  boolRichTextTools={boolRichTextTools}
                  value={
                    findArrayElementByLanguage(data, selectedLanguage) &&
                    findArrayElementByLanguage(data, selectedLanguage).text
                  }
                  handleChangeValue={handleChangeTextTranslated}
                  height={200}
                />
                {/* <Editor
                  apiKey="7e5qugyswmfji644700m0pos9pozwpesrtdbyflsqx2s0zsf"
                  value={
                    findArrayElementByLanguage(data, selectedLanguage) &&
                    findArrayElementByLanguage(data, selectedLanguage).text
                  }
                  init={{
                    branding: false,
                    height: 200,
                    menubar: false,
                    plugins: [
                      "advlist autolink lists link image charmap print preview anchor",
                      "searchreplace visualblocks code fullscreen",
                      "insertdatetime media table paste code help wordcount",
                    ],
                    toolbar:
                      "undo redo | formatselect | bold italic backcolor | \
alignleft aligncenter alignright alignjustify | \
bullist numlist outdent indent | removeformat | help|code",
                  }}
                  onEditorChange={handleChangeTextTranslated}
                /> */}
              </td>
            )}
          </tr>

          <tr>
            <td>
              <Text variant="bodyMd" as="p" color="subdued">
                Image
              </Text>
            </td>
            <td>
              <div
                style={{
                  display: "flex",
                  flexDirection: "row",
                  width: "100%",
                }}
              >
                <div style={{ float: "left" }}>
                  <Thumbnail
                    size="large"
                    source={
                      findArrayElementByLanguage(data, "en") &&
                      findArrayElementByLanguage(data, "en").image
                        ? findArrayElementByLanguage(data, "en").image
                        : ""
                    }
                  />
                </div>
                <div
                  style={{
                    width: "100%",
                    marginLeft: "10px",
                  }}
                >
                  <DropZone
                    accept=".png,.jpeg,.jpg,.svg,.json,.gif,.webp"
                    //   type="file"
                    allowMultiple={false}
                    onDrop={handleDropZoneDrop}
                    onDropAccepted={sendImage}
                  >
                    {uploadedFile}
                    {fileUpload}
                  </DropZone>
                </div>
              </div>
              <div className="mt-2">
                <Button
                  outline
                  size="slim"
                  destructive
                  onClick={() => handleDeleteImage("image", "en")}
                >
                  Delete Image
                </Button>
              </div>
            </td>
            {translatedButtonClicked && (
              <td>
                <div
                  style={{
                    display: "flex",
                    flexDirection: "row",
                    width: "100%",
                  }}
                >
                  <div style={{ float: "left" }}>
                    <Thumbnail
                      size="large"
                      source={
                        findArrayElementByLanguage(data, selectedLanguage) &&
                        findArrayElementByLanguage(data, selectedLanguage).image
                          ? findArrayElementByLanguage(data, selectedLanguage)
                              .image
                          : ""
                      }
                    />
                  </div>
                  <div
                    style={{
                      width: "100%",
                      marginLeft: "10px",
                    }}
                  >
                    {/* <DropZone
                      accept=".png,.jpeg,.jpg,.svg,.json"
                      //   type="file"
                      allowMultiple={false}
                      onDrop={handleDropZoneDropTranslated}
                      onDropAccepted={sendImageTranslated}
                    >
                      {uploadedFileTranslated}
                      {fileUploadTranslated}
                    </DropZone> */}

                    <DropZone
                      accept=".png,.jpeg,.jpg,.svg,.json,.gif,.webp"
                      //   type="file"
                      allowMultiple={false}
                      onDrop={handleDropZoneDropTranslated}
                      onDropAccepted={sendImageTranslated}
                    >
                      {uploadedFileTranslated}
                      {fileUploadTranslated}
                    </DropZone>
                  </div>
                </div>
                <div className="mt-2">
                  <Button
                    outline
                    size="slim"
                    destructive
                    onClick={() => handleDeleteImage("image", selectedLanguage)}
                  >
                    Delete Image
                  </Button>
                </div>
              </td>
            )}
          </tr>

          <tr>
            <td>
              <Text variant="bodyMd" as="p" color="subdued">
                PDF / Document
              </Text>
            </td>

            <td>
              <div
                style={{
                  display: "flex",
                  flexDirection: "row",
                  width: "100%",
                }}
              >
                <div style={{ float: "left" }}>
                  <Thumbnail
                    size="large"
                    source={
                      findArrayElementByLanguage(data, "en")?.file_pdf ?? ""
                    }
                  />
                </div>
                <div
                  style={{
                    width: "100%",
                    marginLeft: "10px",
                  }}
                >
                  <DropZone
                    accept=".pdf,.doc,.docx"
                    allowMultiple={false}
                    onDrop={handleDropZoneDropPdf}
                    onDropAccepted={sendPdfFile}
                  >
                    {!pdfFile && (
                      <DropZone.FileUpload actionHint="Upload PDF, DOC, DOCX" />
                    )}
                    {pdfFile && (
                      <Stack>
                        <div>{pdfFile.name}</div>
                      </Stack>
                    )}
                  </DropZone>
                </div>
              </div>

              {/* {pdfFileKey || (object?.details?.file_pdf && (
      <div className="mt-2">
        <Button
          outline
          size="slim"
          destructive
          onClick={() => handleDeleteImage("file_pdf", "en")}
        >
          Delete Document
        </Button>
      </div>
    ))} */}
            </td>
          </tr>
        </tbody>
      </table>
      <Text variant="bodyMd" as="p" fontWeight="medium">
        Image Position
      </Text>
      <Select
        options={optionsPosition}
        value={
          findArrayElementByLanguage(data, "en") &&
          findArrayElementByLanguage(data, "en").position
        }
        onChange={handleSelectChangePosition}
        error={positionError}
        placeholder="Please select"
      />
      <Text>Template: </Text>
      <div className="boxTemplates">
        {props.templates?.length ? (
          props.templates.map((item, index) => {
            return (
              <div
                style={{ marginRight: "1rem" }}
                key={item.id}
                onClick={() => handleChangeTemplate(item.id)}
                className={`divTemplate ${
                  findArrayElementByLanguage(data, "en")
                    ? String(
                        findArrayElementByLanguage(data, "en").template
                      ) === String(item.id) && "borderTemplate"
                    : ""
                }`}
              >
                {item.text && (
                  <div className="templateInstruction">
                    <Tooltip content={item.text}>
                      <img
                        src={instructionImg}
                        width={17}
                        className="templateInstruction"
                      />
                    </Tooltip>
                  </div>
                )}

                <div className="buttonTemplate">
                  {item.image && <img src={item.image} width={30}></img>}
                  <div style={{ marginTop: "0.2rem" }}>
                    <Text color="subdued">{item.description}</Text>
                  </div>
                </div>
              </div>
            );
          })
        ) : (
          <Text color="subdued">No templates added for this section type</Text>
        )}
      </div>
      <Checkbox
        label="Is Active"
        checked={
          findArrayElementByLanguage(data, "en") &&
          findArrayElementByLanguage(data, "en").active
        }
        onChange={handleChange}
      />
      <FormLayout.Group>
        <div style={{ float: "right" }}>
          <Button
            primary
            onClick={handleSave}
            loading={props.isSaving}
            disabled={!accessEditSections()}
          >
            Save
          </Button>
        </div>
      </FormLayout.Group>
      <Modal
        open={activeDelete}
        onClose={handleChangeModalDelete}
        title="Delete Image"
        primaryAction={{
          content: "Yes",
          onAction: handleYesDelete,
          loading: isSaving,
        }}
        secondaryActions={[
          {
            content: "No",
            loading: isSaving,
            onAction: handleChangeModalDelete,
          },
        ]}
      >
        <Modal.Section>
          <TextContainer>
            <p>Are you sure you want to delete this image?</p>
          </TextContainer>
        </Modal.Section>
      </Modal>
      {toastMarkup}
      {isImageUploading ? <LoadingScreen /> : null}
    </FormLayout>
  );
  function handleSave() {
    if (
      findArrayElementByLanguage(data, "en") &&
      !findArrayElementByLanguage(data, "en").position
    ) {
      !findArrayElementByLanguage(data, "en").position &&
        setPositionError("Please select an image position");
    } else {
      props.handleSavingState();
      const form_data = new FormData();
      findArrayElementByLanguage(data, "en") &&
        (findArrayElementByLanguage(data, "en").template === "none"
          ? form_data.append(`template_id`, "")
          : form_data.append(
              `template_id`,
              findArrayElementByLanguage(data, "en").template
            ));
      findArrayElementByLanguage(data, "en") &&
        findArrayElementByLanguage(data, "en").ctaLinkType &&
        form_data.append(
          `cta_link_type`,
          findArrayElementByLanguage(data, "en") &&
            findArrayElementByLanguage(data, "en").ctaLinkType
        );
      findArrayElementByLanguage(data, "en") &&
        findArrayElementByLanguage(data, "en").ctaLinkPage !== null &&
        form_data.append(
          `cta_page_alias`,
          findArrayElementByLanguage(data, "en").ctaLinkPage
        );
      findArrayElementByLanguage(data, "en") &&
        findArrayElementByLanguage(data, "en").ctaLinkBlog !== null &&
        form_data.append(
          `cta_blog_alias`,
          findArrayElementByLanguage(data, "en").ctaLinkBlog
        );
      findArrayElementByLanguage(data, "en") &&
        findArrayElementByLanguage(data, "en").ctaLinkCollection &&
        form_data.append(
          `cta_shopify_collection_title`,
          findArrayElementByLanguage(data, "en").ctaLinkCollection.label
        );
      findArrayElementByLanguage(data, "en") &&
        findArrayElementByLanguage(data, "en").ctaLinkCollection &&
        form_data.append(
          `cta_shopify_collection_id`,
          findArrayElementByLanguage(data, "en").ctaLinkCollection.value
        );
      findArrayElementByLanguage(data, "en") &&
        findArrayElementByLanguage(data, "en").ctaLinkProduct &&
        form_data.append(
          `cta_shopify_product_id`,
          findArrayElementByLanguage(data, "en").ctaLinkProduct.value
        );
      findArrayElementByLanguage(data, "en") &&
        findArrayElementByLanguage(data, "en").ctaLinkProduct &&
        form_data.append(
          `cta_shopify_product_title`,
          findArrayElementByLanguage(data, "en").ctaLinkProduct.label
        );

      findArrayElementByLanguage(data, "en") &&
        findArrayElementByLanguage(data, "en").ctaLinkCollection &&
        form_data.append(
          `cta_shopify_collection_handle`,
          findArrayElementByLanguage(data, "en").ctaLinkCollection.handle
        );
      findArrayElementByLanguage(data, "en") &&
        findArrayElementByLanguage(data, "en").ctaLinkProduct &&
        form_data.append(
          `cta_shopify_product_handle`,
          findArrayElementByLanguage(data, "en").ctaLinkProduct.handle
        );
      if (pdfFileKey) {
        form_data.append("file_pdf", pdfFileKey);
      }
      data.forEach((selected, index) =>
        form_data.append(`cta_link[${selected.language}]`, selected.ctaLink)
      );
      data.forEach((selected, index) =>
        form_data.append(`title[${selected.language}]`, selected.title)
      );
      data.forEach((selected, index) =>
        form_data.append(`subtitle[${selected.language}]`, selected.subtitle)
      );
      data.forEach((selected, index) =>
        // selected.ctaText &&
        form_data.append(`cta_text[${selected.language}]`, selected.ctaText)
      );
      data.forEach((selected, index) =>
        form_data.append(`text[${selected.language}]`, selected.text)
      );
      form_data.append("is_active", data[data.length - 1].active ? 1 : 0);
      data.forEach((selected, index) =>
        form_data.append(`image[${selected.language}]`, selected.fileImage)
      );
      data[data.length - 1].position &&
        form_data.append("image_position", data[data.length - 1].position);
      props.selectedChannels && props.selectedChannels.length
        ? props.selectedChannels.forEach((selected, index) =>
            form_data.append(`channels[${index}]`, selected)
          )
        : form_data.append(`channels`, []);
      form_data.append("_method", "PATCH");
      axios
        .post(`/pages/${id}/sections/${props.sectionId}`, form_data)
        .then((res) => {
          props.handleSaveAndRefresh();
        })
        .catch(function (error) {
          if (error.response) {
            setToastContent(error.response.data.message);
            toggleActive();
            props.handleResetSavingState();
          }
        });
    }
  }
  function findArrayElementByLanguage(array, language) {
    return array.find((element, index) => {
      return element.language === language;
    });
  }
};
export default ImageWithTextSection;
